import React from "react";
import fondoFlujo from "../../assets/image/stella/fondo-web.png";
import Buy from "../../widgets/buy";
import Hire from "../../widgets/Hire";

function Contract() {
    return (
        <section className="relative py-5 md:py-[112px] overflow-hidden">
            {/* Fondo */}
            <div
                className="absolute inset-0 bg-no-repeat bg-cover bg-center z-0"
                style={{
                    backgroundImage: `linear-gradient(180deg, #00000085, #141414), url(${fondoFlujo})`,
                }}
            ></div>

            {/* Contenido */}
            <div className="relative z-10 container intersect:animate-in slide-in-from-left intersect-once duration-1250">
                <div className="p-5 md:p-12 md:w-1/2 flex flex-col text-white">
                    <h2 className="text-[28px] md:text-5xl font-bold">
                        StellaTV Oficial
                    </h2>

                    <h3 className="mt-5 text-2xl md:text-4xl font-semibold">
                        Disfrute sin Presedentes!
                    </h3>

                    <div className="mt-5">
                        Puede disfrutar de todos los contenidos en dispositivos Android como:{" "}
                        <strong>
                            celulares, tablet, smart tv, fire tv stick, tv box,
                            google tv, google chromecast 4ta generación
                        </strong>.
                    </div>

                    <div className="mt-4">
                        <strong>App Stella TV Oficial</strong>: Todo el contenido en un solo lugar!
                    </div>

                    <Hire label={'CONTRATAR'}/>
                </div>
            </div>
        </section>
    );
}

export default Contract;
